import React from "react";
import "./burgerIcon.scss";

// Three bars that morph into an X when `open` is true.
const BurgerIcon = ({ open = false }) => (
  <span className={`burger${open ? " burger--open" : ""}`} aria-hidden="true">
    <span className="burger__bar" />
    <span className="burger__bar" />
    <span className="burger__bar" />
  </span>
);

export default BurgerIcon;
